export const state = () => ({
  show: false,
  vacations: [],
})

export const mutations = {
  setVacationsAlert: (state, payload) => {
    state.vacations = payload
    state.show = true
  },
  setShowVacationsAlert: (state, payload) => {
    state.show = payload
  },
}
